Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = configReducer;

var _constants = require('../constants');

var _analytics = require('../utils/analytics');

function configReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    analyticsConfig: _analytics.defaultAnalyticsConfig
  };
  var action = arguments[1];

  if (action.type === _constants.ADD_CONFIG) {
    return _extends({}, state, {
      analyticsConfig: _extends({}, _analytics.defaultAnalyticsConfig, action.analyticsConfig)
    });
  } else if (action.type === _constants.UPDATE_ANALYTICS_CONFIG) {
    return _extends({}, state, {
      analyticsConfig: _extends({}, state.analyticsConfig, action.analyticsConfig)
    });
  }

  return state;
}